const sliderInit = (isUpdate) => {
  if (
    document.querySelectorAll('.js-media-list') &&
    document.querySelectorAll('.js-media-list').length > 0
  ) {
    document.querySelectorAll('.js-media-list').forEach((elem, index) => {
      let prevButton = elem.querySelector(
        '.product__slider-nav .swiper-button-prev'
      );
      let nextButton = elem.querySelector(
        '.product__slider-nav .swiper-button-next'
      );
      let pagination = elem.querySelector('.product__pagination');
      let slider = new Swiper(elem, {
        slidesPerView:
          elem
            .closest('.product__outer')
            .classList.contains('product__outer--full-screen') ||
            elem
              .closest('.product__outer')
              .classList.contains('product__outer--single-aside') ||
            elem
              .closest('.product__outer')
              .classList.contains('product__outer--thumbs-aside')
            ? 1
            : 1.1,
        spaceBetween: elem
          .closest('.product__outer')
          .classList.contains('product__outer--multiple-top')
          ? 0
          : 1,
        autoHeight: true,
        freeMode: {
          enabled: true,
          momentum: true,
        },
        speed: 500,
        freeMode: {
          enabled: !!elem
            .closest('.product__outer')
            .classList.contains('product__outer--multiple-top'),
          sticky: true,
        },
        navigation: {
          nextEl: nextButton,
          prevEl: prevButton,
        },
        pagination: {
          el: pagination,
          type: 'bullets',
          clickable: true,
        },
        thumbs: {
          swiper: elem.nextElementSibling.querySelector('.js-media-sublist')
            ? elem.nextElementSibling.querySelector('.js-media-sublist').swiper
            : '',
        },
        breakpoints: {
          1200: {
            slidesPerView:
              elem
                .closest('.product__outer')
                .classList.contains('product__outer--full-screen') ||
                elem
                  .closest('.product__outer')
                  .classList.contains('product__outer--single-aside') ||
                elem
                  .closest('.product__outer')
                  .classList.contains('product__outer--thumbs-aside')
                ? 1
                : 2.37,
          },
        },
        on: {
          afterInit: function (swiper) {
            if (document.querySelector('.product__outer--multiple-top')) {
              document
                .querySelectorAll('.product__media-toggle')
                .forEach((elem, index) => {
                  elem.addEventListener('click', (e) => {
                    var target = e.currentTarget;

                    if (
                      document.querySelector('.js-popup-slider') &&
                      document.querySelector('.js-popup-slider').swiper
                    ) {
                      document
                        .querySelector('.js-popup-slider')
                        .swiper.slideTo(index);
                    }
                  });
                });
            }
          },
          slideChangeTransitionStart: function () {
            if (document.querySelector('.js-media-sublist')) {
              document
                .querySelector('.js-media-sublist')
                .swiper.slideTo(
                  document.querySelector('.js-media-list').swiper.activeIndex
                );
            }
          },
          slideChange: function () {
            window.pauseAllMedia();
            this.params.noSwiping = false;

            if (
              document.querySelector('.js-popup-slider') &&
              document.querySelector('.js-popup-slider').swiper &&
              !document.querySelector('.product__outer--multiple-top')
            ) {
              document
                .querySelector('.js-popup-slider')
                .swiper.slideTo(this.activeIndex);
            }
          },
          slideChangeTransitionEnd: function () {
            if (this.slides[this.activeIndex].querySelector('model-viewer')) {
              this.slides[this.activeIndex]
                .querySelector('.shopify-model-viewer-ui__button--poster')
                .removeAttribute('hidden');
            }
          },
          touchStart: function () {
            if (this.slides[this.activeIndex].querySelector('model-viewer')) {
              if (
                !this.slides[this.activeIndex]
                  .querySelector('model-viewer')
                  .classList.contains('shopify-model-viewer-ui__disabled')
              ) {
                this.params.noSwiping = true;
                this.params.noSwipingClass = 'swiper-slide';
              } else {
                this.params.noSwiping = false;
              }
            }
          },
        },
      });

      if (isUpdate) {
        setTimeout(function () {
          slider.update();
        }, 800);
      }
    });
  }
};

const subSliderInit = (isUpdate) => {
  if (
    document.querySelectorAll('.js-media-sublist') &&
    document.querySelectorAll('.js-media-sublist').length > 0
  ) {
    document.querySelectorAll('.js-media-sublist').forEach((elem, index) => {
      let subSlider = new Swiper(elem, {
        slidesPerView: 4,
        freeMode: {
          enabled: true,
          momentum: true,
        },
        spaceBetween: 8,
        direction: 'horizontal',
        freeMode: false,
        watchSlidesProgress: true,
        watchSlidesVisibility: true,
        autoHeight: true,
        on: {
          afterInit: function () {
            //this.params.slidesPerView = this.slides.length === 2 ? 2 : 3;
          },
          touchEnd: function (s, e) {
            let range = 5;
            let diff = (s.touches.diff = s.isHorizontal()
              ? s.touches.currentX - s.touches.startX
              : s.touches.currentY - s.touches.startY);
            if (diff < range || diff > -range) s.allowClick = true;
          },
        },
        //transitionStart: function () {
        //	document
        //		.querySelector(".js-media-list")
        //		.swiper.slideTo(
        //			document.querySelector(".js-media-sublist").swiper.activeIndex,
        //		);
        //},
        breakpoints: {
          1200: {
            spaceBetween: 4,
            direction: 'vertical',
            slidesPerView: 'auto',
          },
        },
      });

      const sliderResizeObserve = new ResizeObserver((entries) => {
        const [entry] = entries;

        if (entry.contentRect.width >= 1200) {
          setTimeout(() => {
            const sliders = document.querySelectorAll('.js-media-list');
            const thumbs = document.querySelectorAll('.product__media-sublist');
            const sliderHeight = sliders[index].getBoundingClientRect().height;
            thumbs[index].style.height = `${sliderHeight - 1}px`;
          }, 400);
        }
      });

      if (document.querySelector('.product-section'))
        sliderResizeObserve.observe(document.querySelector('.product-section'));

      if (isUpdate) {
        setTimeout(function () {
          subSlider.update();
        }, 800);
      }
    });
  }
};

const popupSliderInit = (isUpdate) => {
  if (document.querySelector('.js-popup-slider')) {
    let popupSlider = new Swiper(document.querySelector('.js-popup-slider'), {
      slidesPerView: 1,
      freeMode: {
        enabled: true,
        momentum: true,
      },
      navigation: {
        nextEl: '.product-media-modal .product__slider-nav .swiper-button-next',
        prevEl: '.product-media-modal .product__slider-nav .swiper-button-prev',
      },
      pagination: {
        el: '.product-media-modal .product__pagination',
        type: 'bullets',
        clickable: true,
      },
      on: {
        afterInit: function () {
          if (
            document.querySelector(
              '.product__outer--static-multicolumns-aside'
            ) ||
            document.querySelector('.product__outer--static-column-aside')
          ) {
            document
              .querySelectorAll('.product__media-list .product__media-toggle')
              .forEach((elem, index) => {
                elem.addEventListener('click', (e) => {
                  if (
                    document.querySelector('.js-popup-slider') &&
                    document.querySelector('.js-popup-slider').swiper
                  ) {
                    document
                      .querySelector('.js-popup-slider')
                      .swiper.slideTo(index);
                  }
                });
              });
          }
        },
        slideChange: function () {
          window.pauseAllMedia();
          this.params.noSwiping = false;
          document
            .querySelector('.product-media-modal__content')
            .classList.remove('zoom');
        },
        touchMove: function () {
          document
            .querySelector('.product-media-modal__content')
            .classList.remove('zoom');
        },
        slideChangeTransitionEnd: function () {
          if (this.slides[this.activeIndex].querySelector('model-viewer')) {
            this.slides[this.activeIndex]
              .querySelector('.shopify-model-viewer-ui__button--poster')
              .removeAttribute('hidden');
          }
        },
        touchStart: function () {
          if (this.slides[this.activeIndex].querySelector('model-viewer')) {
            if (
              !this.slides[this.activeIndex]
                .querySelector('model-viewer')
                .classList.contains('shopify-model-viewer-ui__disabled')
            ) {
              this.params.noSwiping = true;
              this.params.noSwipingClass = 'swiper-slide';
            } else {
              this.params.noSwiping = false;
            }
          }
        },
      },
    });

    if (isUpdate) {
      setTimeout(function () {
        popupSlider.update();
      }, 800);
    }
  }
};

if (navigator.userAgent.indexOf('iPhone') > -1) {
  document
    .querySelector('[name=viewport]')
    .setAttribute(
      'content',
      'width=device-width, initial-scale=1, maximum-scale=1'
    );
}

function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}

document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
  summary.setAttribute('role', 'button');
  summary.setAttribute('aria-expanded', 'false');

  if (summary.nextElementSibling.getAttribute('id')) {
    summary.setAttribute('aria-controls', summary.nextElementSibling.id);
  }

  summary.addEventListener('click', (event) => {
    event.currentTarget.setAttribute(
      'aria-expanded',
      !event.currentTarget.closest('details').hasAttribute('open')
    );
  });

  if (summary.closest('header-drawer')) return;
  summary.parentElement.addEventListener('keyup', onKeyUpEscape);
});

function onKeyUpEscape(event) {
  if (event.code && event.code.toUpperCase() !== 'ESCAPE') return;

  const openDetailsElement = event.target.closest('details[open]');
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector('summary');
  openDetailsElement.removeAttribute('open');
  summaryElement.setAttribute('aria-expanded', false);
  summaryElement.focus();
}

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (
      event.target !== container &&
      event.target !== last &&
      event.target !== first
    )
      return;

    document.addEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function () {
    document.removeEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function (event) {
    if (event.code && event.code.toUpperCase() !== 'TAB') return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if (
      (event.target === container || event.target === first) &&
      event.shiftKey
    ) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener('focusout', trapFocusHandlers.focusout);
  document.addEventListener('focusin', trapFocusHandlers.focusin);

  elementToFocus.focus();
}

function pauseAllMedia() {
  document.querySelectorAll('.js-youtube').forEach((video) => {
    video.contentWindow.postMessage(
      '{"event":"command","func":"' + 'pauseVideo' + '","args":""}',
      '*'
    );
  });
  document.querySelectorAll('.js-vimeo').forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', '*');
  });
  document.querySelectorAll('video').forEach((video) => video.pause());
  document.querySelectorAll('product-model').forEach((model) => {
    if (model.modelViewerUI) model.modelViewerUI.pause();
  });
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener('focusin', trapFocusHandlers.focusin);
  document.removeEventListener('focusout', trapFocusHandlers.focusout);
  document.removeEventListener('keydown', trapFocusHandlers.keydown);

  if (elementToFocus && !elementToFocus.classList.contains('card-focused'))
    elementToFocus.focus();
}

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input');
    this.changeEvent = new Event('change', { bubbles: true });

    this.querySelectorAll('button').forEach((button) => {
      this.setMinimumDisable();

      button.addEventListener('click', this.onButtonClick.bind(this));
    });

    var eventList = ['paste', 'input'];

    for (event of eventList) {
      this.input.addEventListener(event, function (e) {
        const numberRegex = /^0*?[1-9]\d*$/;

        if (
          numberRegex.test(e.currentTarget.value) ||
          e.currentTarget.value === ''
        ) {
          e.currentTarget.value;
        } else {
          e.currentTarget.value = 1;
        }

        if (e.currentTarget.value === 1 || e.currentTarget.value === '') {
          this.previousElementSibling.classList.add('disabled');
        } else {
          this.previousElementSibling.classList.remove('disabled');
        }
      });
    }

    this.input.addEventListener('focusout', function (e) {
      if (e.currentTarget.value === '') {
        e.currentTarget.value = 1;
      }
    });
  }

  setMinimumDisable() {
    if (this.input.value == 1) {
      this.querySelector('button[name="minus"]').classList.add('disabled');
    } else {
      this.querySelector('button[name="minus"]').classList.remove('disabled');
    }
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;

    event.target.name === 'plus' ? this.input.stepUp() : this.input.stepDown();
    if (previousValue !== this.input.value)
      this.input.dispatchEvent(this.changeEvent);

    this.setMinimumDisable();
  }
}

customElements.define('quantity-input', QuantityInput);

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

const serializeForm = (form) => {
  const obj = {};
  const formData = new FormData(form);
  for (const key of formData.keys()) {
    obj[key] = formData.get(key);
  }
  return JSON.stringify(obj);
};

function fetchConfig(type = 'json') {
  return {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Accept: `application/${type}`,
    },
  };
}

/*
 * Shopify Common JS
 *
 */
if (typeof window.Shopify == 'undefined') {
  window.Shopify = {};
}

Shopify.bind = function (fn, scope) {
  return function () {
    return fn.apply(scope, arguments);
  };
};

Shopify.setSelectorByValue = function (selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function (target, eventName, callback) {
  target.addEventListener
    ? target.addEventListener(eventName, callback, false)
    : target.attachEvent('on' + eventName, callback);
};

Shopify.postLink = function (path, options) {
  options = options || {};
  var method = options['method'] || 'post';
  var params = options['parameters'] || {};

  var form = document.createElement('form');
  form.setAttribute('method', method);
  form.setAttribute('action', path);

  for (var key in params) {
    var hiddenField = document.createElement('input');
    hiddenField.setAttribute('type', 'hidden');
    hiddenField.setAttribute('name', key);
    hiddenField.setAttribute('value', params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function (
  country_domid,
  province_domid,
  options
) {
  this.countryEl = document.getElementById(country_domid);
  this.provinceEl = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(
    options['hideElement'] || province_domid
  );

  Shopify.addListener(
    this.countryEl,
    'change',
    Shopify.bind(this.countryHandler, this)
  );

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function () {
    var value = this.countryEl.getAttribute('data-default');
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function () {
    var value = this.provinceEl.getAttribute('data-default');
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function (e) {
    var opt = this.countryEl.options[this.countryEl.selectedIndex];
    var raw = opt.getAttribute('data-provinces');
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = 'none';
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement('option');
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = '';
    }
  },

  clearOptions: function (selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function (selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement('option');
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  },
};

class MenuDrawer extends HTMLElement {
  constructor() {
    super();

    this.mainNav = this.closest('header');

    this.mainNav = this.closest('header');
    this.mainDetailsToggle = this.querySelector('details');
    const summaryElements = this.querySelectorAll('summary');
    this.addAccessibilityAttributes(summaryElements);

    if (navigator.platform === 'iPhone')
      document.documentElement.style.setProperty(
        '--viewport-height',
        `${window.innerHeight}px`
      );

    this.addEventListener('keyup', this.onKeyUp.bind(this));
    this.addEventListener('focusout', this.onFocusOut.bind(this));
    this.bindEvents();
  }

  bindEvents() {
    this.querySelectorAll('summary').forEach((summary) =>
      summary.addEventListener('click', this.onSummaryClick.bind(this))
    );
    this.querySelectorAll('button').forEach((button) => {
      if (this.querySelector('.toggle-scheme-button') === button) return;
      if (this.querySelector('.header__localization-button') === button) return;
      if (this.querySelector('.header__localization-lang-button') === button)
        return;
      button.addEventListener('click', this.onCloseButtonClick.bind(this));
    });
  }

  addAccessibilityAttributes(summaryElements) {
    summaryElements.forEach((element) => {
      element.setAttribute('role', 'button');
      element.setAttribute('aria-expanded', false);
      element.setAttribute('aria-controls', element.nextElementSibling.id);
    });
  }

  onKeyUp(event) {
    if (event.code && event.code.toUpperCase() !== 'ESCAPE') return;

    const openDetailsElement = event.target.closest('details[open]');
    if (!openDetailsElement) return;

    openDetailsElement === this.mainDetailsToggle
      ? this.closeMenuDrawer(this.mainDetailsToggle.querySelector('summary'))
      : this.closeSubmenu(openDetailsElement);
  }

  onSummaryClick(event) {
    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
    const isOpen = detailsElement.hasAttribute('open');

    if (detailsElement === this.mainDetailsToggle) {
      if (isOpen) event.preventDefault();
      isOpen
        ? this.closeMenuDrawer(summaryElement)
        : this.openMenuDrawer(summaryElement);
    } else {
      trapFocus(
        summaryElement.nextElementSibling,
        detailsElement.querySelector('button')
      );

      setTimeout(() => {
        detailsElement.classList.add('menu-opening');
      });
    }
  }

  openMenuDrawer(summaryElement) {
    setTimeout(() => {
      this.mainNav?.classList.add('menu-opening');
      this.mainDetailsToggle.classList.add('menu-opening');
    });
    summaryElement.setAttribute('aria-expanded', true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus = false) {
    if (event !== undefined) {
      this.mainNav?.classList.remove('menu-opening');
      this.mainDetailsToggle.classList.remove('menu-opening');
      this.mainDetailsToggle.querySelectorAll('details').forEach((details) => {
        details.removeAttribute('open');
        details.classList.remove('menu-opening');
      });
      this.mainDetailsToggle
        .querySelector('summary')
        .setAttribute('aria-expanded', false);
      document.body.classList.remove(
        `overflow-hidden-${this.dataset.breakpoint}`
      );
      removeTrapFocus(elementToFocus);
      this.closeAnimation(this.mainDetailsToggle);
      this.header =
        this.header || document.querySelector('.shopify-section-header');
      const main = document.querySelector('main');
      if (
        main
          .querySelectorAll('.shopify-section')[0]
          ?.classList.contains('section--has-overlay') &&
        !this.header.classList.contains('animate')
      ) {
        this.header.classList.add('color-background-1', 'color-background-3');
      }
      if (
        this.header.classList.contains('color-background-1') &&
        !this.header.classList.contains('shopify-section-header-sticky')
      ) {
        this.header.classList.add('color-background-3');
      }
    }
  }

  onFocusOut(event) {
    setTimeout(() => {
      if (
        this.mainDetailsToggle.hasAttribute('open') &&
        !this.mainDetailsToggle.contains(document.activeElement)
      )
        if (this.classList.contains('mobile-facets__wrapper'))
          this.closeMenuDrawer();
        else this.closeMenuDrawer(event);
    });
  }

  onCloseButtonClick(event) {
    const detailsElement = event.currentTarget.closest('details');
    this.closeSubmenu(detailsElement);
  }

  closeSubmenu(detailsElement) {
    detailsElement.classList.remove('menu-opening');
    removeTrapFocus();
    this.closeAnimation(detailsElement);
  }

  closeAnimation(detailsElement) {
    let animationStart;

    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        detailsElement.removeAttribute('open');
        if (detailsElement.closest('details[open]')) {
          trapFocus(
            detailsElement.closest('details[open]'),
            detailsElement.querySelector('summary')
          );
        }
      }
    };

    window.requestAnimationFrame(handleAnimation);
  }
}

customElements.define('menu-drawer', MenuDrawer);

class HeaderDrawer extends MenuDrawer {
  constructor() {
    super();
  }

  openMenuDrawer(summaryElement) {
    this.header =
      this.header || document.querySelector('.shopify-section-header');
    this.borderOffset =
      this.borderOffset ||
        this.closest('.header-wrapper').classList.contains(
          'header-wrapper--border-bottom'
        )
        ? 1
        : 0;
    document.documentElement.style.setProperty(
      '--header-bottom-position',
      `${parseInt(
        this.header.getBoundingClientRect().bottom - this.borderOffset
      )}px`
    );

    if (
      this.header.classList.contains('color-background-3') &&
      !this.header.classList.contains('shopify-section-header-sticky')
    ) {
      this.header.classList.remove('color-background-3');
    }

    const main = document.querySelector('main');
    if (
      main
        .querySelectorAll('.shopify-section')[0]
        ?.classList.contains('section--has-overlay')
    ) {
      this.header.classList.remove('color-background-3');
    }

    setTimeout(() => {
      this.mainNav.classList.add('menu-opening');
      this.mainDetailsToggle.classList.add('menu-opening');
    });

    summaryElement.setAttribute('aria-expanded', true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }
}

customElements.define('header-drawer', HeaderDrawer);

class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="ModalClose-"]').addEventListener(
      'click',
      this.hide.bind(this, false)
    );
    this.addEventListener('keyup', (event) => {
      if (event.code && event.code.toUpperCase() === 'ESCAPE') this.hide();
    });
    if (this.classList.contains('media-modal')) {
      this.addEventListener('pointerup', (event) => {
        if (
          event.pointerType === 'mouse' &&
          !event.target.closest('deferred-media, product-model')
        )
          this.hide();
      });
    } else {
      this.addEventListener('click', (event) => {
        if (event.target === this) this.hide();
      });
    }
  }

  connectedCallback() {
    if (this.moved) return;
    this.moved = true;
    document.body.appendChild(this);
  }

  show(opener) {
    this.openedBy = opener;
    const popup = this.querySelector('.template-popup');
    document.body.classList.add('overflow-hidden');
    this.setAttribute('open', '');
    if (popup) popup.loadContent();
    trapFocus(this, this.querySelector('[role="dialog"]'));
    window.pauseAllMedia();
  }

  hide() {
    let isOpen = false;

    this.removeAttribute('open');
    removeTrapFocus(this.openedBy);
    window.pauseAllMedia();

    document.querySelectorAll('body > quick-add-modal').forEach((el) => {
      if (el.hasAttribute('open')) {
        isOpen = true;
      }
    });

    if (!isOpen) {
      document.body.classList.remove('overflow-hidden');
      document.body.dispatchEvent(new CustomEvent('modalClosed'));
    }

    const images = document.querySelector('.product-media-modal__content');

    if (images) {
      images.classList.remove('zoom');
    }
  }
}

customElements.define('modal-dialog', ModalDialog);

class ModalOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector('button');

    if (!button) return;
    button.addEventListener('click', () => {
      const modal = document.querySelector(this.getAttribute('data-modal'));
      if (modal) modal.show(button);
    });
  }
}

customElements.define('modal-opener', ModalOpener);

class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="Deferred-Poster-"]')?.addEventListener(
      'click',
      this.loadContent.bind(this)
    );
  }

  loadContent() {
    if (!this.getAttribute('loaded')) {
      const content = document.createElement('div');
      content.appendChild(
        this.querySelector('template').content.firstElementChild.cloneNode(true)
      );

      this.setAttribute('loaded', true);
      window.pauseAllMedia();
      this.appendChild(
        content.querySelector('video, model-viewer, iframe')
      ).focus();

      if (
        this.closest('.swiper')?.swiper.slides[
          this.closest('.swiper').swiper.activeIndex
        ].querySelector('model-viewer')
      ) {
        if (
          !this.closest('.swiper')
            .swiper.slides[
            this.closest('.swiper').swiper.activeIndex
          ].querySelector('model-viewer')
            .classList.contains('shopify-model-viewer-ui__disabled')
        ) {
          this.closest('.swiper').swiper.params.noSwiping = true;
          this.closest('.swiper').swiper.params.noSwipingClass = 'swiper-slide';
        }
      }
    }
  }
}

customElements.define('deferred-media', DeferredMedia);

class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.addEventListener("change", this.onVariantChange);
  }

  onVariantChange() {
    this.updateOptions();
    this.updateMasterId();
    this.toggleAddButton(true, "", false);
    this.updatePickupAvailability();
    this.updateVariantStatuses();

    if (!this.currentVariant) {
      this.toggleAddButton(true, "", true);
      this.setUnavailable();
    } else {
      if (!this.closest("floated-form") && this.currentVariant.featured_media) {
        this.updateMedia(`${this.dataset.section}-${this.currentVariant.featured_media.id}`);
      }
      this.updateURL();
      this.updateVariantInput();
      this.renderProductInfo();
    }

    // check engraving option
    this.checkEngravingOption();
	}

  // 
  checkEngravingOption() {
      console.log('Engraving option found');
      console.log(this.currentVariant);

      // dispatch event to update engraving sections
      document.dispatchEvent(new CustomEvent("variant:engraving", {
        detail: {
          variant: this.currentVariant
        },
        bubbles: true
      }));
  }

	//
	syncVariantDisplays() {
		let formControls = document.querySelectorAll('.product-form__controls');
		formControls.forEach((formControl) => {
		  let formLegend = formControl.querySelector(
			'.product-form__group-name span'
		  );
		  if (formLegend) {
			formLegend.textContent = this.currentVariant.option1;
		  }
	
		  let formOptions = formControl.querySelectorAll(
			'input[type="radio"], option'
		  );
		  formOptions.forEach((formOption) => {
			if (formOption.value === this.currentVariant?.option1) {
			  formOption.classList.add('checked');
			} else {
			  formOption.classList.remove('checked');
			}
		  });
		});
	
		// data-product-form-buy
		const productFormBuyAll = document.querySelectorAll(
		  '[data-product-form-buy], [data-buy-with-flower]'
		);
		if (productFormBuyAll.length > 0) {
		  productFormBuyAll.forEach((productFormBuy) => {
			if (this.currentVariant.available) {
			  productFormBuy.classList.remove('disabled');
			  productFormBuy.innerHTML = `<span>${window.variantStrings.buy}</span>`;
			} else {
			  productFormBuy.classList.add('disabled');
			  productFormBuy.innerHTML = `<span>${window.variantStrings.soldOut}</span>`;
			}
		  });
		}
	}

  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll(".js-radio-colors"));

    this.options = Array.from(
      this.querySelectorAll("select"),
      (select) => select.value,
    ).concat(
      fieldsets.map((fieldset) => {
        return Array.from(fieldset.querySelectorAll("input")).find(
          (radio) => radio.checked,
        ).value;
      }),
    );
  }

  updateMasterId() {
    if (this.variantData || this.querySelector('[type="application/json"]')) {
      this.currentVariant = this.getVariantData().find((variant) => {
        this.options.sort();
        variant.options.sort();

        return !variant.options
          .map((option, index) => {
            return this.options[index] === option;
          })
          .includes(false);
      });
    }
  }

  isHidden(elem) {
    const styles = window.getComputedStyle(elem);
    return styles.display === "none" || styles.visibility === "hidden";
  }

  updateMedia(mediaId) {
    if (!this.currentVariant || !this.currentVariant?.featured_media) return;

    const currentSection = document.querySelector(
      `[data-section="main-${this.dataset.section}"]`,
    );

    if (currentSection) {
      this.mediaList = currentSection.querySelector(".product__media-list");
      const activeMedia = this.mediaList.querySelector(
        `[data-media-id="${mediaId}"]`,
      );
      this.mediaList.querySelectorAll("[data-media-id]").forEach((element) => {
        element.classList.remove("active");
      });
      if (activeMedia) activeMedia.classList.add("active");
    }

    const swiperWrappers = document.querySelectorAll(".product__media-wrapper");

    swiperWrappers.forEach((elem) => {
      if (!this.isHidden(elem)) {
        const newMedia = elem.querySelector(
          `[data-media-id="${this.dataset.section}-${this.currentVariant.featured_media.id}"]`,
        );

        if (elem.querySelector(".js-media-list")) {
          elem
            .querySelector(".js-media-list")
            .swiper.slideTo(
              elem
                .querySelector(".js-media-list")
                .swiper.slides.indexOf(newMedia),
            );
        }
      }
    });
  }

  updateURL() {
    if (!this.classList.contains("featured-product-radios")) {
      if (!this.currentVariant || this.dataset.updateUrl === "false") return;
      window.history.replaceState(
        {},
        "",
        `${this.dataset.url}?variant=${this.currentVariant.id}`,
      );
    }
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(
      `#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`,
    );
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event("change", { bubbles: true }));
    });
  }

  updateVariantStatuses() {
    const selectedOptionOneVariants = this.variantData.filter(
      (variant) => this.querySelector(":checked")?.value === variant.option1,
    );
    const inputWrappers = [...this.querySelectorAll(".product-form__controls")];
    inputWrappers.forEach((option, index) => {
      if (index === 0) return;
      const optionInputs = [
        ...option.querySelectorAll('input[type="radio"], option'),
      ];
      const previousOptionSelected =
        inputWrappers[index - 1].querySelector(":checked")?.value;
      const availableOptionInputsValue = selectedOptionOneVariants
        .filter(
          (variant) =>
            variant.available &&
            variant[`option${index}`] === previousOptionSelected,
        )
        .map((variantOption) => variantOption[`option${index + 1}`]);
      this.setInputAvailability(optionInputs, availableOptionInputsValue);
    });
  }

  setInputAvailability(listOfOptions, listOfAvailableOptions) {
    listOfOptions.forEach((input) => {
      if (listOfAvailableOptions.includes(input.getAttribute("value"))) {
        if (input.tagName === "OPTION") {
          input.innerText = input.getAttribute("value");
        } else if (input.tagName === "INPUT") {
          input.classList.remove("disabled");
        }
      } else {
        if (input.tagName === "OPTION") {
          input.innerText =
            window.variantStrings.unavailable_with_option.replace(
              "[value]",
              input.getAttribute("value"),
            );
        } else if (input.tagName === "INPUT") {
          input.classList.add("disabled");
        }
      }
    });
  }

  updatePickupAvailability() {
    const pickUpAvailability = document.querySelector("pickup-availability");
    if (!pickUpAvailability) return;

    if (this.currentVariant && this.currentVariant.available) {
      pickUpAvailability.fetchAvailability(this.currentVariant.id);
    } else {
      pickUpAvailability.removeAttribute("available");
      pickUpAvailability.innerHTML = "";
    }
  }

  renderProductInfo() {
    const requestedVariantId = this.currentVariant.id;
    const sectionId = this.dataset.originalSection
      ? this.dataset.originalSection
      : this.dataset.section;

    fetch(
      `${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.originalSection
        ? this.dataset.originalSection
        : this.dataset.section
      }`,
    )
      .then((response) => response.text())
      .then((responseText) => {
        // prevent unnecessary ui changes from abandoned selections
        if (this.currentVariant.id !== requestedVariantId) return;

        const html = new DOMParser().parseFromString(responseText, "text/html");
        const destination = document.getElementById(
          `price-${this.dataset.section}`,
        );
        const source = html.getElementById(
          `price-${this.dataset.originalSection
            ? this.dataset.originalSection
            : this.dataset.section
          }`,
        );
        const skuSource = html.getElementById(
          `Sku-${this.dataset.originalSection
            ? this.dataset.originalSection
            : this.dataset.section
          }`,
        );
        const skuDestination = document.getElementById(
          `Sku-${this.dataset.section}`,
        );
        const inventorySource = html.getElementById(
          `Inventory-${this.dataset.originalSection
            ? this.dataset.originalSection
            : this.dataset.section
          }`,
        );
        const inventoryDestination = document.getElementById(
          `Inventory-${this.dataset.section}`,
        );
        const colorNameSource = html.getElementById(
          `ColorName-${this.dataset.originalSection
            ? this.dataset.originalSection
            : this.dataset.section
          }`,
        );
        const colorNameDestination = document.getElementById(
          `ColorName-${this.dataset.section}`,
        );

        if (source && destination) destination.innerHTML = source.innerHTML;
        if (inventorySource && inventoryDestination)
          inventoryDestination.innerHTML = inventorySource.innerHTML;
        if (skuSource && skuDestination) {
          skuDestination.innerHTML = skuSource.innerHTML;
          skuDestination.classList.toggle(
            "visibility-hidden",
            skuSource.classList.contains("visibility-hidden"),
          );
        }
        if (colorNameSource && colorNameDestination)
          colorNameDestination.innerHTML = colorNameSource.innerHTML;

        const price = document.getElementById(`price-${this.dataset.section}`);

        if (price) price.classList.remove("visibility-hidden");

        if (inventoryDestination)
          inventoryDestination.classList.toggle(
            "visibility-hidden",
            inventorySource.innerText === "",
          );

        this.toggleAddButton(
          !this.currentVariant.available,
          window.variantStrings.soldOut,
        );
      });
  }

  toggleAddButton(disable = true, text, modifyClass = true) {
    const productForm = document.getElementById(
      `product-form-${this.dataset.section}`,
    );
    if (!productForm) return;
    const addButton = productForm.querySelector('[name="add"]');
    const addButtonText = productForm.querySelector('[name="add"] > span');
    if (!addButton) return;

    if (disable) {
      addButton.setAttribute("disabled", "disabled");
      if (text) addButtonText.textContent = text;
    } else {
      addButton.removeAttribute("disabled");
      addButtonText.textContent = window.variantStrings.addToCart;
    }

    if (!modifyClass) return;
  }

  setUnavailable() {
    const button = document.getElementById(
      `product-form-${this.dataset.section}`,
    );
    const addButton = button.querySelector('[name="add"]');
    const price = document.getElementById(`price-${this.dataset.section}`);
    const inventory = document.getElementById(
      `Inventory-${this.dataset.section}`,
    );
    const sku = document.getElementById(`Sku-${this.dataset.section}`);

    if (!addButton) return;
    this.toggleAddButton(true, window.variantStrings.unavailable);
    if (price) price.classList.add("visibility-hidden");
    if (inventory) inventory.classList.add("visibility-hidden");
    if (sku) sku.classList.add("visibility-hidden");
  }

  getVariantData() {
    this.variantData =
      this.variantData ||
      JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }
}

customElements.define("variant-selects", VariantSelects);

class VariantRadios extends VariantSelects {
  constructor() {
    super();
  }

  setInputAvailability(listOfOptions, listOfAvailableOptions) {
    listOfOptions.forEach((input) => {
      if (listOfAvailableOptions.includes(input.getAttribute("value"))) {
        input.classList.remove("disabled");
      } else {
        input.classList.add("disabled");
      }
    });
  }

  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll("fieldset"));
    this.options = fieldsets.map((fieldset) => {
      return Array.from(fieldset.querySelectorAll("input")).find(
        (radio) => radio.checked,
      )?.value;
    });
  }
}

customElements.define("variant-radios", VariantRadios);


// js/custom-element/section/product/sticky-form.js
var ProductStickyForm = class extends HTMLElement {
  connectedCallback() {
    // console.log("ProductStickyForm");
    this._setupVisibilityObservers();
  }

  disconnectedCallback() {
    this.intersectionObserver.disconnect();
  }

  set hidden(value) {
    this.toggleAttribute('hidden', value);
    if (value) {
      document.documentElement.style.removeProperty(
        '--cart-notification-offset'
      );
    } else {
      document.documentElement.style.setProperty(
        '--cart-notification-offset',
        `${this.clientHeight}px`
      );
    }
  }

  _setupVisibilityObservers() {
    const paymentContainerElement = document.querySelector('product-form');
    const footerElement = document.querySelector('footer');
    const stickyHeaderOffset = 80;

    //   console.log(paymentContainerElement);

    this._isFooterVisible = this._isPaymentContainerPassed = false;
    this.intersectionObserver = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.target === footerElement) {
            this._isFooterVisible = entry.intersectionRatio > 0;
          }
          if (entry.target === paymentContainerElement) {
            const boundingRect =
              paymentContainerElement.getBoundingClientRect();
            this._isPaymentContainerPassed =
              entry.intersectionRatio === 0 &&
              boundingRect.top + boundingRect.height <= stickyHeaderOffset;
          }
        });
        if (
          window.matchMedia(window.themeVariables.breakpoints.pocket).matches
        ) {
          this.hidden =
            !this._isPaymentContainerPassed || this._isFooterVisible;
        } else {
          this.hidden = !this._isPaymentContainerPassed;
        }
      },
      { rootMargin: `-${stickyHeaderOffset}px 0px 0px 0px` }
    );
  }
};
window.customElements.define('product-sticky-form', ProductStickyForm);

class PasswordViewer {
  constructor() {
    const passwordField = document.querySelectorAll('.field--pass');

    passwordField.forEach((el) => {
      const input = el.querySelector('input');
      const btnWrapper = el.querySelector('.button-pass-visibility');
      const btnOpen = el.querySelector('.icon-eye-close');
      const btnClose = el.querySelector('.icon-eye');

      input.addEventListener('input', () => {
        input.value !== ''
          ? (btnWrapper.style.display = 'block')
          : (btnWrapper.style.display = 'none');
      });

      btnOpen.addEventListener('click', () => {
        input.type = 'text';
        btnOpen.style.display = 'none';
        btnClose.style.display = 'block';
      });

      btnClose.addEventListener('click', () => {
        input.type = 'password';
        btnOpen.style.display = 'block';
        btnClose.style.display = 'none';
      });
    });
  }
}

class ProductRecommendations extends HTMLElement {
  constructor() {
    super();

    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);

      fetch(this.dataset.url)
        .then((response) => response.text())
        .then((text) => {
          const html = document.createElement('div');
          html.innerHTML = text;
          const recommendations = html.querySelector('product-recommendations');
          if (recommendations && recommendations.innerHTML.trim().length) {
            this.innerHTML = recommendations.innerHTML;
          }

          /* Color swatches */
          const generateSrcset = (image, widths = []) => {
            const imageUrl = new URL(image['src']);
            return widths
              .filter((width) => width <= image['width'])
              .map((width) => {
                imageUrl.searchParams.set('width', width.toString());
                return `${imageUrl.href} ${width}w`;
              })
              .join(', ');
          };

          const createImageElement = (image, classes, sizes, productTitle) => {
            const previewImage = image['preview_image'];
            const newImage = new Image(
              previewImage['width'],
              previewImage['height']
            );
            newImage.className = classes;
            newImage.alt = image['alt'] || productTitle;
            newImage.sizes = sizes;
            newImage.src = previewImage['src'];
            newImage.srcset = generateSrcset(
              previewImage,
              [165, 360, 533, 720, 940, 1066]
            );
            newImage.loading = 'lazy';
            return newImage;
          };

          const checkSwatches = () => {
            document
              .querySelectorAll('.js-color-swatches-wrapper')
              .forEach((wrapper) => {
                wrapper
                  .querySelectorAll('.js-color-swatches input')
                  .forEach((input) => {
                    input.addEventListener('click', (event) => {
                      const primaryImage =
                        wrapper.querySelector('.media--first');
                      const secondaryImage =
                        wrapper.querySelector('.media--second');
                      const handleProduct = wrapper.dataset.product;

                      if (event.currentTarget.checked && primaryImage) {
                        wrapper
                          .querySelector('.js-color-swatches-link')
                          .setAttribute(
                            'href',
                            event.currentTarget.dataset.variantLink
                          );
                        if (
                          wrapper.querySelector(
                            '.card__add-to-cart button[name="add"]'
                          )
                        ) {
                          wrapper
                            .querySelector(
                              '.card__add-to-cart button[name="add"]'
                            )
                            .setAttribute('aria-disabled', false);
                          if (
                            wrapper.querySelector(
                              '.card__add-to-cart button[name="add"] > span'
                            )
                          ) {
                            wrapper
                              .querySelector(
                                '.card__add-to-cart button[name="add"] > span'
                              )
                              .classList.remove('hidden');
                            wrapper
                              .querySelector(
                                '.card__add-to-cart button[name="add"] .sold-out-message'
                              )
                              .classList.add('hidden');
                          }
                          wrapper.querySelector(
                            '.card__add-to-cart input[name="id"]'
                          ).value = event.currentTarget.dataset.variantId;
                        }
                        const currentColor = event.currentTarget.value;

                        jQuery.getJSON(
                          window.Shopify.routes.root +
                          `products/${handleProduct}.js`,
                          function (product) {
                            const variant = product.variants.filter(
                              (item) =>
                                item.featured_media != null &&
                                item.options.includes(currentColor)
                            )[0];

                            if (variant) {
                              const newPrimaryImage = createImageElement(
                                variant['featured_media'],
                                primaryImage.className,
                                primaryImage.sizes,
                                product.title
                              );

                              if (newPrimaryImage.src !== primaryImage.src) {
                                let flag = false;
                                if (secondaryImage) {
                                  const secondaryImagePathname = new URL(
                                    secondaryImage.src
                                  ).pathname;
                                  const newPrimaryImagePathname = new URL(
                                    newPrimaryImage.src
                                  ).pathname;

                                  if (
                                    secondaryImagePathname ==
                                    newPrimaryImagePathname
                                  ) {
                                    primaryImage.remove();
                                    secondaryImage.classList.remove(
                                      'media--second'
                                    );
                                    secondaryImage.classList.add(
                                      'media--first'
                                    );
                                    flag = true;
                                  }
                                }
                                if (flag == false) {
                                  primaryImage.animate(
                                    { opacity: [1, 0] },
                                    {
                                      duration: 200,
                                      easing: 'ease-in',
                                      fill: 'forwards',
                                    }
                                  ).finished;
                                  setTimeout(function () {
                                    primaryImage.replaceWith(newPrimaryImage);
                                    newPrimaryImage.animate(
                                      { opacity: [0, 1] },
                                      { duration: 200, easing: 'ease-in' }
                                    );
                                    if (secondaryImage) {
                                      secondaryImage.remove();
                                    }
                                  }, 200);
                                }
                              }
                            }
                          }
                        );
                      }
                    });
                  });
              });
          };

          checkSwatches();

          const calcTop = (section) => {
            const imageWrapper = section.querySelectorAll('.card__inner');
            let top = 0;

            if (imageWrapper.length > 0) {
              top = imageWrapper[0].offsetHeight / 2;
            } else {
              top = 50;
            }

            return top;
          };

          const initSlider = () => {
            document
              .querySelectorAll('.js-recommendation-swiper')
              .forEach((elem, index) => {
                let mobileLayout = 1;
                if (elem.dataset.mobileLayout) {
                  mobileLayout = elem.dataset.mobileLayout;
                }
                let slider = new Swiper(elem, {
                  slidesPerView: mobileLayout,
                  slidesPerGroup: 1,
                  freeMode: {
                    enabled: true,
                    momentum: true,
                  },
                  spaceBetween: 16,
                  speed: 1000,
                  navigation: {
                    nextEl: elem.querySelector(
                      '.product-recommendations__slider-nav .swiper-button-next'
                    ),
                    prevEl: elem.querySelector(
                      '.product-recommendations__slider-nav .swiper-button-prev'
                    ),
                  },
                  breakpoints: {
                    576: {
                      slidesPerView: 2,
                      slidesPerGroup: 2,
                    },
                    750: {
                      slidesPerView: 3,
                      slidesPerGroup: 3,
                    },
                    1200: {
                      slidesPerView: 4,
                      slidesPerGroup: 4,
                      spaceBetween: 24,
                    },
                  },
                });
              });
          };

          const initSection = () => {
            const section = this;

            const sectionResizeObserver = new ResizeObserver((entries) => {
              const [entry] = entries;
              let top = calcTop(section);
              if (section.querySelector('.product-recommendations__slider-nav'))
                section.querySelector(
                  '.product-recommendations__slider-nav'
                ).style.top = top + 'px';
            });

            sectionResizeObserver.observe(section);

            initSlider();
          };

          initSection();
        })
        .catch((e) => {
          console.error(e);
        });
    };

    new IntersectionObserver(handleIntersection.bind(this), {
      rootMargin: '0px 0px 200px 0px',
    }).observe(this);
  }
}

customElements.define('product-recommendations', ProductRecommendations);

(function () {
  const initHeaderOverlay = () => {
    // console.log("initHeaderOverlay");
    const main = document.getElementById('MainContent');
    const sections = main.querySelectorAll('.shopify-section');
    if (sections.length > 0) {
      const sectionFirstChild = sections[0].querySelector(
        '.section--has-overlay'
      );
      const headerGroupSections = document.querySelectorAll(
        '.shopify-section-group-header-group'
      );
      const header = document.querySelector('.shopify-section-header');

      if (sectionFirstChild) {
        if (sectionFirstChild.classList.contains('section--has-overlay')) {
          if (headerGroupSections[headerGroupSections.length - 1] === header) {
            sections[0].classList.remove('not-margin');
            header.classList.add('color-background-1', 'color-background-3');
          } else {
            sections[0].classList.add('not-margin');
            header.classList.remove('color-background-1', 'color-background-3');
          }
        } else {
          sections[0].classList.remove('not-margin');
          header.classList.remove('color-background-1', 'color-background-3');
        }
      }
    }
  };

  initHeaderOverlay();

  document.addEventListener('shopify:section:load', function () {
    initHeaderOverlay();
  });

  document.addEventListener('shopify:section:unload', function () {
    initHeaderOverlay();
  });

  document.addEventListener('shopify:section:reorder', function () {
    initHeaderOverlay();
  });
})();

function formatMoney(cents, format = '') {
  if (typeof cents === 'string') {
    cents = cents.replace('.', '');
  }
  let value = '';
  const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
  const formatString = format || theme.moneyFormat;

  function formatWithDelimiters(
    number,
    precision = 2,
    thousands = ',',
    decimal = '.'
  ) {
    if (isNaN(number) || number == null) {
      return 0;
    }

    number = (number / 100.0).toFixed(precision);

    const parts = number.split('.');
    const dollarsAmount = parts[0].replace(
      /(\d)(?=(\d\d\d)+(?!\d))/g,
      `$1${thousands}`
    );
    const centsAmount = parts[1] ? decimal + parts[1] : '';

    return dollarsAmount + centsAmount;
  }

  switch (formatString.match(placeholderRegex)[1]) {
    case 'amount':
      value = formatWithDelimiters(cents, 2);
      break;
    case 'amount_no_decimals':
      value = formatWithDelimiters(cents, 0);
      break;
    case 'amount_with_comma_separator':
      value = formatWithDelimiters(cents, 2, '.', ',');
      break;
    case 'amount_no_decimals_with_comma_separator':
      value = formatWithDelimiters(cents, 0, '.', ',');
      break;
  }

  return formatString.replace(placeholderRegex, value);
}

class VerticalMarquee extends HTMLElement {
  constructor() {
    super();
    this._speed = 1;
    this._direction = 'down';
    this._position = 0;
    this._contentWrappers = [];
    this._isInitialized = false;
    this._pauseOnHover = this.getAttribute('pause-on-hover') === 'true';
    this.isPaused = false;

    // Bind methods to maintain correct 'this' context
    this._pause = this._pause.bind(this);
    this._resume = this._resume.bind(this);
  }

  static get observedAttributes() {
    return ['scrolling-speed', 'direction', 'pause-on-hover'];
  }

  attributeChangedCallback(name, oldValue, newValue) {
    if (name === 'scrolling-speed') {
      this._speed = parseFloat(newValue) || 1;
      if (this._isInitialized) this._resetAnimation();
    }

    if (name === 'direction') {
      this._direction = newValue === 'up' ? 'up' : 'down';
      if (this._isInitialized) this._resetAnimation();
    }

    if (name === 'pause-on-hover') {
      this._pauseOnHover = newValue === 'true';
      this._setupEventListeners();
    }
  }

  connectedCallback() {
    if (!this._isInitialized) {
      this._setupStyles();
      this._setupContent();
      this._initMarquee();
      this._setupEventListeners();
      this._isInitialized = true;
    }
  }

  _setupEventListeners() {
    // Remove existing listeners first to prevent duplicates
    const cards = this.querySelectorAll('.custom-block-card');

    cards.forEach((card) => {
      card.removeEventListener('mouseenter', this._pause);
      card.removeEventListener('mouseleave', this._resume);
    });

    // Only add listeners if pause-on-hover is enabled
    if (this._pauseOnHover) {
      cards.forEach((card) => {
        card.addEventListener('mouseenter', this._pause);
        card.addEventListener('mouseleave', this._resume);
      });
    }
  }

  _setupStyles() {
    this.style.display = 'block';
    this.style.position = 'relative';
    this.style.width = '100%';
  }

  _pause() {
    this.isPaused = true;
    if (this._animationFrame) {
      cancelAnimationFrame(this._animationFrame);
      this._animationFrame = null;
    }
  }

  _resume() {
    if (this.isPaused) {
      this.isPaused = false;
      this._animate(); // Resume animation
    }
  }

  _setupContent() {
    // Store original content
    const originalContent = Array.from(this.children);

    // Create content wrappers
    this._contentWrappers = [
      this._createContentWrapper(originalContent),
      this._createContentWrapper(originalContent),
    ];

    // Clear original content and append wrappers
    this.innerHTML = '';
    this._contentWrappers.forEach((wrapper) => this.appendChild(wrapper));

    // Position the second wrapper based on direction
    this._positionSecondWrapper();
  }

  _createContentWrapper(originalContent) {
    const wrapper = document.createElement('div');
    wrapper.style.position = 'absolute';
    wrapper.style.width = '100%';
    wrapper.style.display = 'flex';
    wrapper.style.flexDirection = 'column';

    // Clone and append original content
    originalContent.forEach((element) => {
      const clonedElement = element.cloneNode(true);
      wrapper.appendChild(clonedElement);
    });

    return wrapper;
  }

  _positionSecondWrapper() {
    const firstWrapper = this._contentWrappers[0];
    const secondWrapper = this._contentWrappers[1];
    const wrapperHeight = firstWrapper.offsetHeight;

    if (this._direction === 'down') {
      // Second wrapper starts above the first
      secondWrapper.style.transform = `translateY(-${wrapperHeight}px)`;
    } else {
      // Second wrapper starts below the first
      secondWrapper.style.transform = `translateY(${wrapperHeight}px)`;
    }
  }

  _initMarquee() {
    const animate = () => {
      if (this.isPaused) return;

      // Determine direction multiplier
      const directionMultiplier = this._direction === 'down' ? 1 : -1;

      // Update position
      this._position += this._speed * directionMultiplier;

      // Get wrapper height
      const wrapperHeight = this._contentWrappers[0].offsetHeight;

      // Reset position when wrapper is fully scrolled
      if (Math.abs(this._position) >= wrapperHeight) {
        this._position = 0;
      }

      // Apply transform to both wrappers
      this._contentWrappers[0].style.transform = `translateY(${this._position}px)`;
      this._contentWrappers[1].style.transform = `translateY(${this._position +
        (this._direction === 'down' ? -wrapperHeight : wrapperHeight)
        }px)`;

      // Continue animation
      this._animationFrame = requestAnimationFrame(animate);
    };

    // Start the animation
    this._animate = animate;
    animate();
  }

  _resetAnimation() {
    // Cancel previous animation
    if (this._animationFrame) {
      cancelAnimationFrame(this._animationFrame);
    }

    // Reset position and reinitialize
    this._position = 0;
    this._positionSecondWrapper();
    this._initMarquee();
  }

  // Optional method to pause the marquee
  pause() {
    this._pause();
  }

  // Optional method to resume the marquee
  resume() {
    this._resume();
  }

  // Cleanup when element is removed
  disconnectedCallback() {
    if (this._animationFrame) {
      cancelAnimationFrame(this._animationFrame);
    }

    // Remove event listeners to prevent memory leaks
    const cards = this.querySelectorAll('.custom-block-card');
    cards.forEach((card) => {
      card.removeEventListener('mouseenter', this._pause);
      card.removeEventListener('mouseleave', this._resume);
    });
  }
}

// Define the custom element if not already defined
if (!window.customElements.get('vertical-marquee')) {
  window.customElements.define('vertical-marquee', VerticalMarquee);
}

class CustomFinancementCard extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.querySelector('button[button-expand]').addEventListener(
      'click',
      () => {
        this.classList.add('expanded');
      }
    );
  }

  disconnectedCallback() {
    this.querySelector('button[button-expand]').removeEventListener(
      'click',
      () => {
        this.classList.add('expanded');
      }
    );
  }
}

if (!window.customElements.get('custom-financement-card')) {
  window.customElements.define(
    'custom-financement-card',
    CustomFinancementCard
  );
}

class CustomDropdown extends HTMLElement {
  constructor() {
    super();
    this.selectedElement = this.querySelector('.custom-dropdown__selected');
    this.optionsContainer = this.querySelector('.custom-dropdown__options');
    this.options = this.querySelectorAll('.custom-dropdown__option');
    this.hiddenSelect = this.querySelector('.custom-dropdown__select');
    this.selectedText = this.querySelector('.selected-text');

    this.init();
  }

  init() {
    // Toggle dropdown on click
    this.selectedElement.addEventListener('click', () => this.toggleDropdown());

    // Handle option selection
    this.options.forEach((option) => {
      option.addEventListener('click', (e) => this.handleOptionSelect(e));
    });

    // Close dropdown when clicking outside
    document.addEventListener('click', (e) => {
      if (!this.contains(e.target)) {
        this.closeDropdown();
      }
    });

    // Keyboard navigation
    this.selectedElement.addEventListener('keydown', (e) =>
      this.handleKeydown(e)
    );
  }

  toggleDropdown() {
    this.optionsContainer.classList.toggle('active');
    this.selectedElement.classList.toggle('active');

    if (this.optionsContainer.classList.contains('active')) {
      // Set aria-expanded when opened
      this.selectedElement.setAttribute('aria-expanded', 'true');
    } else {
      this.selectedElement.setAttribute('aria-expanded', 'false');
    }
  }

  closeDropdown() {
    this.optionsContainer.classList.remove('active');
    this.selectedElement.classList.remove('active');
    this.selectedElement.setAttribute('aria-expanded', 'false');
  }

  handleOptionSelect(e) {
    const selectedValue = e.target.dataset.value;
    const selectedText = e.target.textContent;

    // Update the visible text
    this.selectedText.textContent = selectedText;
    this.selectedElement.dataset.value = selectedValue;

    // Update the hidden select
    this.hiddenSelect.value = selectedValue;

    // Trigger change event on the select
    this.hiddenSelect.dispatchEvent(new Event('change', { bubbles: true }));

    // Remove active class from all options and add to selected
    this.options.forEach((option) => option.classList.remove('selected'));
    e.target.classList.add('selected');

    this.closeDropdown();
  }

  handleKeydown(e) {
    const isExpanded = this.optionsContainer.classList.contains('active');

    switch (e.key) {
      case 'Enter':
      case ' ':
        e.preventDefault();
        if (!isExpanded) {
          this.toggleDropdown();
        }
        break;
      case 'Escape':
        if (isExpanded) {
          this.closeDropdown();
        }
        break;
      case 'ArrowDown':
        e.preventDefault();
        if (!isExpanded) {
          this.toggleDropdown();
        }
        this.focusNextOption();
        break;
      case 'ArrowUp':
        e.preventDefault();
        if (!isExpanded) {
          this.toggleDropdown();
        }
        this.focusPreviousOption();
        break;
    }
  }

  focusNextOption() {
    const currentOption = this.querySelector('.custom-dropdown__option:focus');
    if (!currentOption) {
      this.options[0]?.focus();
      return;
    }
    const nextOption = currentOption.nextElementSibling;
    if (nextOption) {
      nextOption.focus();
    }
  }

  focusPreviousOption() {
    const currentOption = this.querySelector('.custom-dropdown__option:focus');
    if (!currentOption) {
      this.options[this.options.length - 1]?.focus();
      return;
    }
    const previousOption = currentOption.previousElementSibling;
    if (previousOption) {
      previousOption.focus();
    }
  }
}
customElements.define('custom-dropdown', CustomDropdown);

class ContactForm extends HTMLElement {
  constructor() {
    super();

    // form controls
    this.form = this.querySelector('form');
    this.submitButton = this.form.querySelector('button[type="submit"]');

    // get all the form required fields
    this.requiredFields = this.form.querySelectorAll('input[required], select[required], textarea[required]');

  }

  connectedCallback() {

    // add class when required fields change and have value
    this.requiredFields.forEach((field) => {
      field.addEventListener('change', this.handleFieldChange.bind(this));
    });

    // add class when required fields change and have value
    this.requiredFields.forEach((field) => {
      field.addEventListener('keyup', this.handleFieldChange.bind(this));
    });

    this.init();
  }

  disconnectedCallback() {
    // remove event listeners
    this.requiredFields.forEach((field) => {
      field.removeEventListener('change', this.handleFieldChange.bind(this));
    });

    // remove event listeners
    this.requiredFields.forEach((field) => {
      field.removeEventListener('keyup', this.handleFieldChange.bind(this));
    });
  }

  init() {
    // disable submit button by default if form has required fields
    this.validateForm();
  }

  handleFieldChange(event) {
    const field = event.target;

    // add or remove has-value class based on field value
    if (field.value) {
      field.classList.add('has-value');
    } else {
      field.classList.remove('has-value');
    }

    // refresh form validation
    this.validateForm();
  }

  validateForm() {
    const allFieldsFilled = Array.from(this.requiredFields).every(field => field.classList.contains('has-value') && field.value && field.value !== '');

    // update the submit button disabled state
    this.submitButton.disabled = !allFieldsFilled;
  }
}
customElements.define('contact-form', ContactForm);

class CustomAddToCalendar extends HTMLElement {
  constructor() {
    super();

    // French to English month mapping
    this.monthsMap = {
      "janvier": "January",
      "février": "February",
      "mars": "March",
      "avril": "April",
      "mai": "May",
      "juin": "June",
      "juillet": "July",
      "aout": "August",
      "septembre": "September",
      "octobre": "October",
      "novembre": "November",
      "décembre": "December"
    };

    this.eventTitle = this.getAttribute("data-event-title");
    this.eventPlace = this.getAttribute("data-event-place");
    this.eventAddress = this.getAttribute("data-event-address");
    this.eventDescription = this.getAttribute("data-event-description");

    this.toggleButton = this.querySelector("#toggleCalendarDropdown");
    this.dropdown = this.querySelector("#calendarDropdown");
  }

  connectedCallback() {
    // Close dropdown on click outside or key press escape
    document.addEventListener('click', this.closeDropdown.bind(this));
    document.addEventListener('keydown', this.closeDropdown.bind(this));

    // Toggle dropdown on click
    this.toggleButton.addEventListener('click', this.toggleDropdown.bind(this));

    // Download calendar on click
    this.dropdown.addEventListener('click', this.downloadCalendarEvent.bind(this));
  }

  disconnectedCallback() {
    this.toggleButton.removeEventListener('click', this.toggleDropdown.bind(this));
    this.dropdown.removeEventListener('click', this.downloadCalendarEvent.bind(this));
  }

  toggleDropdown() {
    this.dropdown.classList.toggle("hidden");
  }

  closeDropdown(event) {
    // console.log(event);
    if (
      event.type === 'keydown' && event.code.toUpperCase() === 'ESCAPE' ||
      !this.dropdown.classList.contains("hidden") && event.target != this.toggleButton
    ) {
      this.dropdown.classList.add("hidden");
    }
  }

  /**
   * Converts a French date string (e.g., "samedi le 15 février 2025") into a JavaScript Date object.
   */
  parseFrenchDate(frenchDate) {
    let date = frenchDate.replace('le ', '');
    date = date.replaceAll(',', '');

    const parts = date.split(" ");

    if (parts.length < 4) return null;

    const day = parts[1]; // e.g., "15"
    const monthFrench = parts[2]; // e.g., "février"
    const year = parts[3]; // e.g., "2025"

    const monthEnglish = this.monthsMap[monthFrench.toLowerCase()];

    if (!monthEnglish) {
      // console.error("Invalid month:", monthFrench);
      return new Date(`${day} ${monthFrench} ${year}`);
      // return null;
    }

    return new Date(`${day} ${monthEnglish} ${year}`);
  }

  /**
  * Creates a JavaScript Date object from a given formatted date (YYYY-MM-DD) and time string (e.g., "14h00").
  */
  createDateTime(formattedDate, time) {
    let theTime = time.toLowerCase().replaceAll('pm', '');
    theTime = theTime.toLowerCase().replaceAll('am', '');

    // pad start is not working for some reason
    const [hours, minutes] = theTime.replace(/\s/g, '').split(":");
    if (!hours || !minutes) return null;

    return new Date(`${formattedDate}T${hours.padStart(2, "0")}:${minutes.padStart(2, "0")}:00`);
  }

  downloadCalendarEvent(event) {
    if (!event.target.classList.contains("calendar-option")) return;

    // close dropdown
    this.toggleDropdown();

    // Extract event data
    const day = event.target.dataset.day.trim();
    const time = event.target.dataset.time.trim();
    const [startTime, endTime] = time.split("-");

    // console.log(day, time, startTime, endTime);

    // Convert French date to JavaScript Date object
    const parsedDate = this.parseFrenchDate(day);
    if (!parsedDate) return;

    // Format date as YYYY-MM-DD
    const formattedDate = parsedDate.toISOString().split("T")[0];

    // Convert time strings to JavaScript Date objects
    const startDate = this.createDateTime(formattedDate, startTime);
    const endDate = this.createDateTime(formattedDate, endTime);

    if (!startDate || !endDate) {
      console.error("Error parsing event times");
      return;
    }

    // Format for Google Calendar
    const eventStart = startDate.toISOString().replace(/-|:|\.\d+/g, "");
    const eventEnd = endDate.toISOString().replace(/-|:|\.\d+/g, "");

    // Google Calendar URL
    const googleCalendarUrl = `https://calendar.google.com/calendar/render?action=TEMPLATE&text=${encodeURIComponent(
      this.eventTitle
    )}&dates=${eventStart}/${eventEnd}&details=${encodeURIComponent(this.eventDescription)}&location=${encodeURIComponent(this.eventAddress)}`;

    window.open(googleCalendarUrl, "_blank");

    // Hide the dropdown after selection
    this.dropdown.classList.add("hidden");
  }
}

customElements.define('custom-add-to-calendar', CustomAddToCalendar);


document.addEventListener('DOMContentLoaded', () => {
  if (window.location.hash) {
    setTimeout(() => {
      const section = document.querySelector(window.location.hash);
      if (section) {
        console.log(`Scrolling to: ${window.location.hash}`);
        let sectionTop = section.getBoundingClientRect().top + window.scrollY - 130;

        window.scrollTo({
          top: sectionTop,
          behavior: 'smooth',
        });
      }
    }, 100); // Delay allows the page to finish layout calculations
  }
});


/**
 * JS BLOCK LINK
 * Select all elements with the class .js-block-link, iterates over them, and adds an event
 * listener to each. When clicked, the browser will navigate to the URL specified
 * in the data-block-target attribute of each element.
 * If data-blank is present and its value is true then open in a new tab.
 */
document.addEventListener('DOMContentLoaded', function () {
  // Select all elements with the class '.js-block-link'
  var links = document.querySelectorAll('.js-block-link');

  // Iterate over each element
  links.forEach(function (link) {
    // Add a click event listener to each link
    link.addEventListener('click', function () {
      // Retrieve the URL from the 'data-target' attribute
      var url = link.getAttribute('data-block-target');
      // Check if the 'data-blank' attribute is present
      var openInNewTab = link.getAttribute('data-blank');

      // Navigate to the URL
      if (url) {
        if (openInNewTab) {
          // If 'data-blank' is present, open the URL in a new tab/window
          window.open(url, '_blank');
        } else {
          // Otherwise, navigate in the same tab
          window.location.href = url;
        }
      }
    });
  });
});

/**
 * JS SCROLL TO SECTION
 * JavaScript snippet that listens for all anchor (<a>) links with href
 * pointing to a section within the page and animates the scroll smoothly
 */
document.addEventListener('DOMContentLoaded', () => {
  document.body.addEventListener('click', (event) => {
    const target = event.target.closest("a[href^='#']");
    if (target && target.getAttribute('href') != '#') {
      event.preventDefault();
      const section = document.querySelector(target.getAttribute('href'));
      if (section) {
        let sectionTop = section.getBoundingClientRect().top - 100;
        window.scrollTo({
          top: sectionTop,
          behavior: 'smooth',
        });
      }
    }
  });
});

/**
 * JS SCROLLABLE CONTAINER
 * to dynamically show/hide the ::before and ::after pseudo-elements
 * based on the scroll position
 */
document.addEventListener('DOMContentLoaded', () => {
  function updateScrollIndicators(container) {
    const isScrollable = container.scrollHeight > container.clientHeight;
    const atTop = container.scrollTop === 0;
    const atBottom =
      container.scrollHeight - container.clientHeight === container.scrollTop;

    container.classList.toggle('show-before', isScrollable && !atTop);
    container.classList.toggle('show-after', isScrollable && !atBottom);
  }

  document.querySelectorAll('.scrollable').forEach((container) => {
    updateScrollIndicators(container); // Initial check
    container.addEventListener('scroll', () =>
      updateScrollIndicators(container)
    );
  });
});

// 
document.addEventListener('DOMContentLoaded', () => {
  const copyLinks = document.querySelectorAll('.copy-btn');
  for (const copyLink of copyLinks) {
    copyLink.addEventListener('click', copyURI);
  }

  function copyURI(evt) {
    evt.preventDefault();
    navigator.clipboard
      .writeText(window.location.href)
      .then(() => {
        const tooltip = document.querySelector('.tooltip');
        console.log(tooltip);
        if (tooltip) {
          tooltip.classList.remove('hidden');
          setTimeout(() => {
            tooltip.classList.add('hidden');
          }, 2000); // Hide tooltip after 2 seconds
        } else {
          console.error('Tooltip element not found');
        }
      })
      .catch((err) => {
        console.error('Failed to copy: ', err);
      });
  }
});

// we create a function to check if avis is related to existing complexe
window.isAvisHasValidComplexe = (expoComplexe) => {
  let complexe_funeraire = null;
  let address_exists = expoComplexe.split(' ');
  let downcase_complex = expoComplexe.toLowerCase() || '';
  
  const complexeBuyingRestriction = window.themeVariables.avisRestrictions.complexe_restriction || false; // true or false

  if(address_exists.length > 1) {
    address_exists = address_exists[1].toLowerCase();

    if(window.themeVariables.localeIsoCode == 'fr') {
      if(address_exists == 'ste-dorothée') {
        address_exists = 'sainte-dorothée';
      } else if(address_exists == 'lasalle') {
        address_exists = 'angrignon';
      } else if(downcase_complex.includes('crématel')) {
        address_exists = 'crématel';
      } else if(downcase_complex.includes('verdun')) {
        address_exists = 'verdun';
      }
    }
    else {
      if(address_exists == 'ste-dorothée') {
        address_exists = 'laval';
      } else if(address_exists == 'pierrefonds') {
        address_exists = 'west island';
      } else if(downcase_complex.includes('crématel')) {
        address_exists = 'crématel';
      } else if(downcase_complex.includes('verdun')) {
        address_exists = 'verdun';
      }
    }

    for (let item of window.themeVariables.complexeFuneraire) {
      let item_name = item.name.toLowerCase();

      if (item_name.includes(address_exists)) {
        complexe_funeraire = item;
        break;
      }
    }
  }

  console.log(complexeBuyingRestriction, ' complexeBuyingRestriction');
  console.log(complexe_funeraire, ' complexe_funeraire');

  return complexeBuyingRestriction === false || complexe_funeraire != null;
}

// Create a window function to check if a date is valid
window.isAvisHasValidDate = (dateString, hourString) => {
  // console.log('Checking Avis Restrictions...');

  const restrictionThreshold = window.themeVariables.avisRestrictions.restriction_threshold; // 48 hours
  // console.log(`Restriction threshold: ${restrictionThreshold} hours`);

  // Always return true if the threshold is 0 or less
  if (restrictionThreshold <= 0) {
    return true;
  }

  // Month mappings (French → English)
  const monthsFrToEn = {
    "janvier": "January", "février": "February", "mars": "March",
    "avril": "April", "mai": "May", "juin": "June",
    "juillet": "July", "août": "August", "septembre": "September",
    "octobre": "October", "novembre": "November", "décembre": "December"
  };

  // Day mappings (French → English)
  const daysFrToEn = {
    "lundi": "Monday", "mardi": "Tuesday", "mercredi": "Wednesday",
    "jeudi": "Thursday", "vendredi": "Friday", "samedi": "Saturday", "dimanche": "Sunday"
  };

  // Detect language based on presence of French months/days
  let isFrench = Object.keys(monthsFrToEn).some(month => dateString.includes(month)) ||
    Object.keys(daysFrToEn).some(day => dateString.includes(day));

  // console.log("Detected Language:", isFrench ? "French" : "English");

  // Convert French date to English for parsing
  if (isFrench) {
    let parts = dateString.trimStart().toLowerCase().replace(" le ", " ").split(" ");
    let dayName = daysFrToEn[parts[0]] || parts[0];
    let day = parts[1];
    let month = monthsFrToEn[parts[2]] || parts[2];
    let year = parts[3];

    dateString = `${dayName}, ${day} ${month} ${year}`;
  }

  // Parse date
  let eventDate = new Date(dateString);
  if (isNaN(eventDate)) {
    console.error("Invalid date format:", dateString);
    return false;
  }

  // console.log("Parsed Event Date:", eventDate);

  // Convert French or English time to a valid format
  let timeParts = hourString.match(/(\d{1,2}):(\d{2})\s?(AM|PM|am|pm)?/g);

  if (!timeParts || timeParts.length === 0) {
    console.error("Invalid time format:", hourString);
    return false;
  }

  // Take the first time in the range
  let [hour, minute] = timeParts[0].split(/[:\s]/).map(Number);
  let period = hourString.includes("AM") || hourString.includes("PM") ? hourString.match(/AM|PM|am|pm/)[0] : null;

  // Convert 12-hour format to 24-hour format if needed
  if (period) {
    if (period.toUpperCase() === "PM" && hour !== 12) hour += 12;
    if (period.toUpperCase() === "AM" && hour === 12) hour = 0;
  }

  eventDate.setHours(hour, minute, 0, 0);
  // console.log("Final Event DateTime:", eventDate);

  // Get the current date/time
  let now = new Date();
  // console.log("Current DateTime:", now);

  // Calculate time difference in hours
  let timeDiffInHours = (eventDate - now) / (1000 * 60 * 60);
  // console.log(`Time Difference: ${timeDiffInHours} hours`);

  // Check if the event is at least restrictionThreshold hours ahead
  return timeDiffInHours >= restrictionThreshold;
};

window.isWithin24HoursAfterExpo = (dateString, hourString) => {
  // console.log('Checking if within 24 hours after event...');
  const hoursAfterEventAllowed = window.themeVariables.avisRestrictions.avis_condolence_threshold; // 24 hours

  // Month mappings (French → English)
  const monthsFrToEn = {
    "janvier": "January", "février": "February", "mars": "March",
    "avril": "April", "mai": "May", "juin": "June",
    "juillet": "July", "août": "August", "septembre": "September",
    "octobre": "October", "novembre": "November", "décembre": "December"
  };

  // Day mappings (French → English)
  const daysFrToEn = {
    "lundi": "Monday", "mardi": "Tuesday", "mercredi": "Wednesday",
    "jeudi": "Thursday", "vendredi": "Friday", "samedi": "Saturday", "dimanche": "Sunday"
  };

  // Detect language based on presence of French months/days
  let isFrench = Object.keys(monthsFrToEn).some(month => dateString.includes(month)) ||
    Object.keys(daysFrToEn).some(day => dateString.includes(day));

  // Convert French date to English for parsing
  if (isFrench) {
    let parts = dateString.trimStart().toLowerCase().replace(" le ", " ").split(" ");
    let dayName = daysFrToEn[parts[0]] || parts[0];
    let day = parts[1];
    let month = monthsFrToEn[parts[2]] || parts[2];
    let year = parts[3];

    dateString = `${dayName}, ${day} ${month} ${year}`;
  }

  // Parse date
  let eventDate = new Date(dateString);
  if (isNaN(eventDate)) {
    console.error("Invalid date format:", dateString);
    return false;
  }

  // Convert French or English time to a valid format
  let timeParts = hourString.match(/(\d{1,2}):(\d{2})\s?(AM|PM|am|pm)?/g);

  if (!timeParts || timeParts.length === 0) {
    console.error("Invalid time format:", hourString);
    return false;
  }

  // Take the first time in the range
  let [hour, minute] = timeParts[0].split(/[:\s]/).map(Number);
  let period = hourString.includes("AM") || hourString.includes("PM") ? hourString.match(/AM|PM|am|pm/)[0] : null;

  // Convert 12-hour format to 24-hour format if needed
  if (period) {
    if (period.toUpperCase() === "PM" && hour !== 12) hour += 12;
    if (period.toUpperCase() === "AM" && hour === 12) hour = 0;
  }

  eventDate.setHours(hour, minute, 0, 0);

  // Get the current date/time
  let now = new Date();

  // Calculate time difference in hours (now - eventDate)
  let timeDiffInHours = (now - eventDate) / (1000 * 60 * 60);

  console.log(timeDiffInHours)

  // Check if we're within the allowed window (within 24 hours after the event)
  // Returns true if event has passed AND we're still within 24 hours after it
  return timeDiffInHours < 0 || (timeDiffInHours >= 0 && timeDiffInHours <= hoursAfterEventAllowed);
};